<template>
  <div>
    <el-dialog
      :title="`應付明細: ${name}(${number})`"
      :visible.sync="dialogRecordVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-table
        :data="list"
        border
        fit
        highlight-current-row
        style="width:100%;height:300px;margin-top:30px;overflow-y:scroll;"
      >
        <el-table-column align="center" label="開始時間" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.begin_time }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="結束時間" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.end_time }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="課程名稱" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="課程類型" width="110">
          <template slot-scope="scope">
            <span>{{ typeToLiterals[scope.row.course_type] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RecordDialog',
  props: {
    dialogRecordVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      number: '',
      name: '',
      list: [],
      typeToLiterals: {
        'tutor': '家教課',
        'group': '團體課'
      }
    }
  },
  methods: {
    open() {
      this.number = this.$parent.currentRecordNumber
      this.name = this.$parent.currentRecordName
      this.list = this.$parent.currentRecordList
    },
    handleClose(done) {
      this.$parent.dialogRecordVisible = false
    }
  }
}
</script>
